
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import {unmountComponentAtNode} from 'react-dom';
import Configdata from './Defaultdata';
import Home from './Home';




import Register from './Register';

import userp from './imgs/profileuser.png';
import sineup from './imgs/sign-up-icon.png';
import search from './imgs/search.png';

import earthback from './imgs/sky.jpg';


import postingimg from './imgs/posting.png';
import { getmessage,wrongmsg,unauthomsg } from './Dynamictable';
import {clearmain,clearprofile} from './clearmem';
import {isvaliduser} from './validation';

class Header extends Component {
	constructor(props: any) {
   	super(props);
	this.state.toggleprofile = false;
	this.state.togglecriteria = false;
	this.state.togglesinup = false;
	this.state.toggleposting = false;


    	this.toggeluserprofile = this.toggeluserprofile.bind(this);
	this.loadsearch = this.loadsearch.bind(this);
	this.loadregister = this.loadregister.bind(this);
	
	
  	}
	state = {
        name: "SIIKAA",
        toggleprofile: false,
	togglecriteria: false,
	togglesinup: false,
        toggleposting: false
    	};

	toggeluserprofile(){
		
		
	};
	loadsearch(){
		
		
		

	};

	loadregister(){
		
	       
		const elesrch = <Register />
		const Pdcivr = document.getElementById('container') as HTMLElement;

                const Pdivr = document.getElementById('profilediv') as HTMLElement;
		//ReactDOM.render(elesrch,Pdivr);
		

		const chkpvisible = this.state.togglesinup == false ? true: false;
		this.setState({ togglesinup: chkpvisible });
		if(chkpvisible){
		ReactDOM.render(elesrch,Pdivr);
		Pdivr.style.display = 'block';
		clearmain();
		}
		else{
		Pdivr.style.display = 'none';
		
		}
		
		this.setState({ toggleprofile: false });
		this.setState({ togglecriteria: false });
		//this.setState({ togglesinup: false });
		Pdcivr.style.display = 'none';
		


		
	};

	



	componentDidMount() {
        //debugger;
     	//this.toggeluserprofile();
     
    	}
       
	
	render() {
		return (
		<form>
		<div className="per100">

			<div id="profilediv" className="sidebar-profile">
   			   <div>
				
				 Profile
			    </div>

			</div>

			<div className="headertopmenu-comp">

				<div className="headertop-submenu-logo" style={{border:'none'}}>
				
				set
				</div>
				<div className="headertop-submenu-cnt" style={{border:'none'}}>
				Citi Home				
				</div>

			</div>


			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				<a  href="#"  onClick={this.toggeluserprofile} title="Profile"><img src={userp} className="per100" /></a>
				</div>

			</div>
			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				<a  href="#"  onClick={this.loadregister} title="Register"><img src={sineup} className="per100" /></a>
				</div>

			</div>
			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				<a  href="#"  onClick={this.loadsearch} title="Search"><img src={search} className="per100" /></a>
				</div>

			</div>

			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				
				</div>

			</div>


		</div>
		</form>
		);
	}

	
}

export default Header;
